// Plugins
import { VueMaskDirective } from 'v-mask';
import VTooltip from 'v-tooltip';
import Vue from 'vue';
import Skeleton from 'vue-loading-skeleton';
import Toast, { POSITION } from 'vue-toastification';
import PortalVue from 'portal-vue';
import Flicking from '@egjs/vue-flicking';
import '@egjs/vue-flicking/dist/flicking.css';
import 'vue-toastification/dist/index.css';
import './styles/scss/toastification-override.scss';
import App from './App.vue';

import '@/plugins/core';
import vuetify from './plugins/vuetify';
import rules from './plugins/Rules';
import VueDebounce from './plugins/vue-debounce';
import RHandler from './plugins/RHandler';
import GlobalPlugin from './plugins/global';
import VeeValidate from './plugins/vee-validate';
import ApiPlugin from './plugins/api.js';
import ModelsPlugin from './plugins/models.js';
import DialogsPlugin from './plugins/dialogs.js';
import DrawersPlugin from './plugins/drawers.js';
import i18n from './plugins/I18n.js';
import DateFns from './plugins/date-fns';
import DatePrint from './plugins/date-print';
import VApiDatatable from 'v-api-datatable';
import { initRouter } from './router';
import store from './store';
import VueDraggableResizable from 'vue-draggable-resizable';

// optionally import default styles
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

Vue.directive('mask', VueMaskDirective);

Vue.use(Skeleton);
Vue.use(VTooltip);
Vue.use(PortalVue);
Vue.use(Flicking);

Vue.use(Toast, {
  position: POSITION.BOTTOM_CENTER,
  maxToasts: 5,
  draggable: false,
  hideProgressBar: true,
  transition: 'Vue-Toastification__fade',
});

Vue.use(VApiDatatable, {});

Vue.use(VueDebounce);
Vue.use(RHandler);
Vue.use(rules);
Vue.use(GlobalPlugin, store);
Vue.use(VeeValidate);
Vue.use(ApiPlugin);
Vue.use(ModelsPlugin);
Vue.use(DateFns);
Vue.use(DatePrint);
Vue.use(DialogsPlugin);
Vue.use(DrawersPlugin);

Vue.component('vue-draggable-resizable', VueDraggableResizable);
Vue.config.productionTip = true;

const { router } = initRouter();

const app = new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
});

app.$mount('#app');
